import {useContext, useState} from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../context/context";
import './footer.css';
import logo from "../../assets/images/logo.svg";

function Footer() {

    const { data, loading, error  } = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);


    return (
        data && !loading && !error && (
        <motion.footer
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.5, delay: 0.25 }}
            onAnimationComplete={() => {
                setShowItems(true);
            }}

        >

            <div

                className="footer__inner"
            >

                <div className="logo"><img alt="студия веб дизайна Феникс Калининград" src={logo} /></div>



                <ul>


                    {
                        data.variablesdata.filter(variable => variable.var === 'city').map((city, index) => (
                            <motion.li key={index} initial={{ opacity: 0, x: 100 }} animate={ showItems ? { opacity: 1, x: 0 } : {}}  transition={{ delay: 0, duration: 0.5 }}>{city.val}</motion.li>
                        ))
                    }


                    {
                    data.variablesdata.filter(variable => variable.var === 'phone').map((phone, index) => (
                    <motion.li key={index} initial={{ opacity: 0, x: 100 }} animate={ showItems ? { opacity: 1, x: 0 } : {}}  transition={{ delay: 0.1, duration: 0.5 }}><a key={index} href={`tel: ${phone.clearedval}`}>{phone.val}</a></motion.li>
                    ))
                    }


                    {
                    data.variablesdata.filter(variable => variable.var === 'email').map((email, index) => (
                    <motion.li key={index} initial={{ opacity: 0, x: 100 }} animate={ showItems ? { opacity: 1, x: 0 } : {}}  transition={{ delay: 0.2, duration: 0.5 }}><a key={index} href={`mailto: ${email.val}`}>{email.val}</a></motion.li>
                        ))
                    }

                </ul>



            </div>


        </motion.footer>

        )
    )
}

export default Footer